import { render } from "./App.vue?vue&type=template&id=96812598"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=96812598&lang=less"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版 - 圆导航\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__